<template>
  <v-container :class="isFromContact ? 'contact' : 'contact-modal'">
    <v-row>
      <v-col>
        <v-img class="mx-auto" :width="screenType === 'smartphone' ? '120' : '170'" :src="screenType === 'smartphone' ? imgMobile : imgDesktop" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <p class="contact-info" v-html="getMessage"></p>
      </v-col>
    </v-row>
    <v-row>
      <v-col :class="['contact-content', isFromContact ? (screenType !== 'desktop' ? 'px-8' : 'px-16') : '']">
        <p
          v-for="(phone, index) of phones"
          :key="`${phone}-${index}`"
          :class="[isFromContact ? 'text-left' : 'text-center', screenType === 'desktop' ? 'pl-7' : '']"
        >
          <v-icon class="mr-5">phone</v-icon>
          {{ phone }}
        </p>
        <p
          v-for="(nunPhone, index) of nunPhones"
          :key="`${nunPhone}-${index}`"
          :class="[isFromContact ? 'text-left' : 'text-center', screenType === 'desktop' ? 'pl-7' : '']"
        >
          <v-icon class="mr-5">headset_mic</v-icon>
          {{ nunPhone }}
        </p>
        <p
          v-for="(email, index) of emails"
          :key="`${email}-${index}`"
          :class="[isFromContact ? 'text-left' : 'text-center', 'contact-email', screenType === 'desktop' ? 'pl-7' : '']"
        >
          <v-icon class="mr-5">email</v-icon>
          <a :href="`mailto:${email}`">{{ email }}</a>
        </p>
        <p
          v-for="(whatsapp, index) of whatsapps"
          :key="`${whatsapp}-${index}`"
          :class="[isFromContact ? 'text-left' : 'text-center', 'contact-whatsapp', screenType === 'desktop' ? 'pl-7' : '']"
        >
          <v-icon class="mr-5">whatsapp</v-icon>
          <a target="_blank" :href="whatsapp.link">{{ whatsapp.number }}</a>
        </p>
      </v-col>
    </v-row>
    <v-row v-if="isFromContact" justify="center" class="mt-8">
      <v-btn
        height="50px"
        :color="getAssets.colors.form.buttonBackground"
        :style="{ color: getAssets.colors.form.buttonFont }"
        @click="$router.push({ path: '/home' })"
        >finalizar</v-btn
      >
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { screenTypeMixin } from '@/mixins/screen-type'

const NUN_PREFIX_PHONES = ['4004', '4003', '0800']

export default {
  name: 'ContactContent',
  mixins: [screenTypeMixin],
  props: {
    isFromContact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['CONTACTS', 'USER_EMAIL', 'GET_ASSETS']),
    nunPhones() {
      if (!this.CONTACTS || !this.CONTACTS.phones) return []
      return this.CONTACTS.phones.filter(phone => NUN_PREFIX_PHONES.includes(phone.slice(0, 4)))
    },
    phones() {
      if (!this.CONTACTS || !this.CONTACTS.phones) return []
      return this.CONTACTS.phones.filter(phone => !NUN_PREFIX_PHONES.includes(phone.slice(0, 4)))
    },
    emails() {
      if (!this.CONTACTS || !this.CONTACTS.emails) return []
      return this.CONTACTS.emails.length < 3 ? this.CONTACTS.emails : [this.CONTACTS.emails[0], this.CONTACTS.emails[1]]
    },
    whatsapps() {
      if (!this.CONTACTS || !this.CONTACTS.whatsapp) return []
      return this.CONTACTS.whatsapp.length < 3 ? this.CONTACTS.whatsapp : [this.CONTACTS.whatsapp[0], this.CONTACTS.whatsapp[1]]
    },
    userEmail() {
      return this.USER_EMAIL
    },
    getAssets() {
      return this.GET_ASSETS
    },
    imgMobile() {
      return require('@/assets/suport.png')
    },
    imgDesktop() {
      return require('@/assets/suport-v2.png')
    },
    getMessage() {
      return this.isFromContact
        ? this.getMessageForDocumentNoAlreadyExists
        : 'O endereço de e-mail é necessário para que possamos te avisar se fomos capazes ou não de realizar a alteração que você está solicitando. Por isso, se você não possui um endereço de e-mail, recomendamos que você entre em contato com a nossa central.'
    },
    getMessageForDocumentNoAlreadyExists() {
      return (
        (this.getAssets.texts && this.getAssets.texts.document_no_already_exists_main) ||
        'Você <strong>já está cadastrado no clube</strong>, mas não possui senha de acesso ou meio de contato para criação de uma nova senha de acesso a área logada. Por isso não conseguimos mais te ajudar por aqui. Por favor entre em contato com a nossa central.'
      )
    }
  }
}
</script>

<style lang="scss">
.contact {
  padding: 40px 30px;
  text-align: center;

  p {
    margin-bottom: 10px;
    max-width: 460px;
  }

  & .contact-info {
    color: #4b525a;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.15px;
    max-width: 460px;
    margin: auto;
  }

  & .contact-content {
    overflow: hidden;
  }

  & .contact-email {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@media screen and (min-width: 599px) {
  .contact {
    padding: 40px 0px;

    & .contact-info {
      padding: 0 15px;
    }
  }

  p {
    margin: auto;
  }
}

.contact-modal {
  & .contact-info {
    color: #6b7580;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    max-width: calc(100% - 30px);
  }

  & a {
    font-size: 16px !important;
    color: #0079f2 !important;
    cursor: pointer;
    text-decoration: underline;
  }

  & .contact-content {
    max-width: calc(100% - 30px);
  }
}
</style>
